import { render, staticRenderFns } from "./BoxEntriesHeaderDate.vue?vue&type=template&id=4be97d0c&scoped=true&"
import script from "./BoxEntriesHeaderDate.vue?vue&type=script&lang=ts&"
export * from "./BoxEntriesHeaderDate.vue?vue&type=script&lang=ts&"
import style0 from "./BoxEntriesHeaderDate.vue?vue&type=style&index=0&id=4be97d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be97d0c",
  null
  
)

export default component.exports